'use client';

import Link from 'next/link';
import type { ComponentProps, MouseEvent } from 'react';
import { trackEvent } from '@/lib/analytics/counterscale';

type Props = ComponentProps<typeof Link> & { event: string };

export function TrackedLink({ event, onClick, ...rest }: Props) {
  return (
    <Link
      {...rest}
      onClick={(e: MouseEvent<HTMLAnchorElement>) => {
        trackEvent(event);
        onClick?.(e);
      }}
    />
  );
}
